import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { SHIFT_CHANGE_TYPES } from 'modules/attendance/store/models/ShiftVersionHistory'

interface DescriptionProps {
  changes: string[]
}

const manualDescription = (changes: string[]): string | null => {
  const { breaks, clock_in_out, creation, location_type, observation } = SHIFT_CHANGE_TYPES

  const hasCreation = changes.includes(creation)
  const hasObservation = changes.includes(observation)
  const hasClockInOut = changes.includes(clock_in_out)
  const hasLocationType = changes.includes(location_type)
  const hasBreaks = changes.includes(breaks)

  if (hasCreation && hasObservation && hasClockInOut) {
    return i18n.t('clock_in.history.types_action.shift_create_edited_observation_edited')
  } else if (hasCreation && hasObservation && hasClockInOut && hasLocationType) {
    return i18n.t(
      'clock_in.history.types_action.shift_create_edited_observation_edited_location_type_edited'
    )
  } else if (hasCreation && hasClockInOut) {
    return i18n.t('clock_in.history.types_action.created_and_edited')
  } else if (hasCreation && hasClockInOut && hasLocationType) {
    return i18n.t('clock_in.history.types_action.created_and_edited_location_type_edited')
  } else if (hasCreation && hasObservation) {
    return i18n.t('clock_in.history.types_action.shift_created_manual_observation_edit')
  } else if (hasCreation && hasLocationType) {
    return i18n.t('clock_in.history.types_action.shift_created_manual_location_type_edit')
  } else if (hasCreation && hasObservation && hasLocationType) {
    return i18n.t(
      'clock_in.history.types_action.shift_created_manual_observation_edit_location_type_edited'
    )
  } else if (hasClockInOut && hasObservation) {
    return i18n.t('clock_in.history.types_action.shift_edited_observation_edited')
  } else if (hasLocationType && hasObservation) {
    return i18n.t('clock_in.history.types_action.location_type_edited_observations_edited')
  } else if (hasClockInOut && hasLocationType) {
    return i18n.t('clock_in.history.types_action.shift_edited_location_type_edited')
  } else if (hasClockInOut && hasObservation && hasLocationType) {
    return i18n.t(
      'clock_in.history.types_action.shift_edited_observation_edited_location_type_edited'
    )
  } else if (hasObservation) {
    return i18n.t('clock_in.history.types_action.observations_edited')
  } else if (hasClockInOut) {
    return i18n.t('clock_in.history.types_action.edited')
  } else if (hasCreation) {
    return i18n.t('clock_in.history.types_action.created_manually')
  } else if (hasBreaks) {
    return i18n.t('clock_in.history.types_action.automatic_break_updated')
  } else if (hasLocationType) {
    return i18n.t('clock_in.history.types_action.location_type_edited')
  }

  return null
}

const Description = ({ changes }: DescriptionProps) => {
  const text = manualDescription(changes)

  if (!text) return null

  return (
    <Box alignItems="center" background="grey800">
      <Text.Normal size="200" color="grey000White">
        {text}
      </Text.Normal>
    </Box>
  )
}

export default observer(Description)
